import React, { lazy, Suspense } from 'react';
import { Icon, Title } from '@landing/ui';
import { useIsSsr } from 'utils/hooks';

import * as styles from './IntroDefault.module.scss';

const Animation = lazy(() => import('components/UI/Animation'));

export default function IntroDefault({ title, subtitle, date, time, location }) {
  const isSsr = useIsSsr();

  return (
    <div className={styles.layout}>
      <Title tag="h1" color="white">
        {title}
      </Title>
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      <div className={styles.details}>
        <div className={styles.detailsItem}>
          <Icon name="calendar" className={styles.detailIcon} />
          <span>{date}</span>
        </div>
        <div className={styles.detailsItem}>
          <Icon name="clock" className={styles.detailIcon} />
          <span>{time}</span>
        </div>
        <div className={styles.detailsItem}>
          <Icon name="marker" className={styles.detailIcon} />
          <span>{location}</span>
        </div>
      </div>
      {!isSsr && (
        <Suspense fallback={null}>
          <Animation preserveAspectRatio className={styles.animation} name="intro" />
        </Suspense>
      )}
    </div>
  );
}
